import React from "react";
import { ReactSVG } from "react-svg";
import Card from "../ClinicalServiceCard";
import NewToolTip from "../../../common/New-ToolTip";
const ServiceSelection = ({ setStartNewService, setSelectedService }) => {
  const comingSoonCards = ["New Modules Coming Soon"];
  const comingSoonTooltipId = "coming-soon-tooltip";
  return (
    <>
      <div className="grid grid-cols-12 gap-10 px-[30px]">
        <div className="col-span-4 min-h-[330px]">
          <Card
            title={"Medication Reviews"}
            newServiceBtnOnClick={() => {
              setSelectedService("Medication Review");
              setStartNewService("Medication Review");
            }}
            followUpBtnOnClick={() => { }}
            isNote={true}
            noteTitle="Annual Medication Reviews"
            noteDescription={
              <>
                Taking three or more prescriptions medications for a chronic
                condition. Can be performed once annually.
                <br /> <br />
                For more information on the program and to assess resources{" "}
                <br />
                provided by the Ministry.{" "}
                <a href="https://www.ontario.ca/page/professional-pharmacy-services" target="_blank">
                  Click here
                </a>
              </>
            }
          // iconName="Med-Review-Icon2"
          />
        </div>
        <div className="col-span-4 min-h-[330px]">
          <Card
            title={"Diabetes Management"}
            comingSoon={true}
          />
        </div>
        <div className="col-span-4 min-h-[330px]">
          <Card
            title={"Vaccine Health & Prevention"}
            comingSoon={true}
          />
        </div>
        <div className="col-span-4 min-h-[330px]">
          <Card
            title={"Minor Ailments"}
            newServiceBtnOnClick={() => {
              setSelectedService("Minor Ailments Prescribing Service");
              setStartNewService("Minor Ailments Prescribing Service");
            }}
            // iconName="rx-minor-ailment"
            followUpBtnOnClick={() => { }}
            isNote={true}
            noteTitle="Minor Ailments"
            position="top"
            noteDescription={
              <div className="flex flex-col gap-4">
                <p>
                  Minor ailments are described as health conditions that can be
                  managed with minimal treatment and/or self-care strategies.
                  Additional criteria include:{" "}
                </p>
                <div className="pl-2">
                  <div className="flex flex-row items-start">
                    <div className="pr-2">•</div>
                    <p>Usually a short-term condition</p>
                  </div>
                  <div className="flex flex-row items-start">
                    <div className="pr-2">•</div>
                    <p>Lab results aren't usually required</p>
                  </div>
                  <div className="flex flex-row items-start">
                    <div className="pr-2">•</div>
                    <p>Low risk of treatment masking underlying conditions</p>
                  </div>
                  <div className="flex flex-row items-start">
                    <div className="pr-2">•</div>
                    <p>
                      No medication or medical history red flags that could
                      suggest a more serious condition
                    </p>
                  </div>
                  <div className="flex flex-row items-start">
                    <div className="pr-2">•</div>
                    <p>Only minimal or short-term follow-up is required</p>
                  </div>
                </div>
                <p>
                  Click {" "}
                  <a href="https://www.ocpinfo.com/practice-education/expanded-scope-of-practice/minor-ailment/" target="_blank" className="underline">
                    here
                  </a> for Full Reference
                </p>
                <p className="font-bold">
                  Powered by the medSask Guidelines for Prescribing for Minor
                  Ailments and Patient Self-Care
                </p>
              </div>
            }
          />
        </div>
        <div className="col-span-4 min-h-[330px]">
          <Card
            title={"Chronic Disease Management"}
            comingSoon={true}
          />
        </div>
        <div className="col-span-4 min-h-[330px]">
          <div className="relative rounded-[4px] h-full overflow-hidden">
            <img
              src="/icons/texture-background.png"
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 p-5 z-10">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-display-sm text-teal-200 mb-16">New Modules Coming Soon</span>
                <div className="relative flex gap-2 mb-16">
                  <ReactSVG
                    src="/icons/information-dark.svg"
                    className="w-5 h-5 cursor-default"
                    data-tooltip-id={comingSoonTooltipId}
                  />
                  <NewToolTip
                    id={comingSoonTooltipId}
                    render={() => (
                      <div className="bg-gray-10 p-2 rounded shadow-md max-w-[360px]">
                        <p className="text-sm font-normal text-teal-300 whitespace-pre-line">
                          This also includes - Pre-Assessment, Follow-Ups, Notifications, and Reporting modules.
                        </p>
                      </div>
                    )}
                    place="bottom"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceSelection;
